import {withTranslation} from "react-i18next";
import {useEffect} from "react";

function TutorHomePage (props) {

    return(<>
        <h3 style={{textAlign: "center"}}>
            Home Tutor/Orientador
        </h3></>
    )
}

export default withTranslation()(TutorHomePage);
